import { enrichChartOfAccounts } from './enrich-charts-of-accounts.js'
import { updateView, viewParams } from './update-view.js'

export function showTableChartsOfAccounts (chartOfAccountResponse, associatedChartOfAccountsResponse, browserAppAccount) {
  viewParams.browserAppAccount = browserAppAccount
  viewParams.associatedChartOfAccounts = associatedChartOfAccountsResponse

  const { chartOfAccounts } = chartOfAccountResponse
  viewParams.allChartOfAccounts = chartOfAccounts.map(function (chartOfAccount) {
    const enrichedChartOfAccount = { ...chartOfAccount }
    return enrichedChartOfAccount
  })

  enrichChartOfAccounts(viewParams.allChartOfAccounts, associatedChartOfAccountsResponse, browserAppAccount)

  updateView()
}
